import { useEffect, useState } from "react";
import { Car } from "lucide-react";
import api from "@/lib/api";

/** Imagen de ticket con autenticación (blob). */
export default function GastoImagen({ gastoId, tieneJustificante = true, cual = "inicio", className, alt = "Ticket" }) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!tieneJustificante || !gastoId) {
      setSrc(null);
      setError(true);
      return undefined;
    }
    let blobUrl;
    let cancelled = false;
    setError(false);
    api.get(`/gastos/${gastoId}/imagen`, { params: { cual }, responseType: "blob" })
      .then(({ data }) => {
        if (cancelled) return;
        blobUrl = URL.createObjectURL(data);
        setSrc(blobUrl);
      })
      .catch(() => {
        if (!cancelled) {
          setSrc(null);
          setError(true);
        }
      });
    return () => {
      cancelled = true;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [gastoId, tieneJustificante, cual]);

  if (error || !tieneJustificante) {
    return (
      <div className={`flex items-center justify-center bg-sky-50 text-sky-600 ${className || ""}`}>
        <Car className="h-7 w-7" />
      </div>
    );
  }
  if (!src) {
    return <div className={`animate-pulse bg-zinc-100 ${className || ""}`} />;
  }
  return <img src={src} alt={alt} className={className} />;
}
